import React from "react"
import { Navigate } from "react-router-dom"
import { useUserStore } from "../store"
import { UNAUTHORIZED } from "./CONSTANTS"
import SuspenseFallback from "../Components/SuspenseFallback/SuspenseFallback"

const ProtectedRoute = ({ permission, permissionsToCheck, children }) => {
  const { permissions = [], permissionsLoaded } = useUserStore()

  if (!permissionsLoaded) {
    return <SuspenseFallback />
  }

  let hasPermission = false
  if (permissionsToCheck) {
    hasPermission = permissionsToCheck.some((p) => permissions.includes(p))
  } else if (permission) {
    hasPermission = permissions.includes(permission)
  } else {
    hasPermission = true
  }

  if (!hasPermission) {
    return <Navigate to={UNAUTHORIZED} replace={true} />
  }

  return children
}

export default ProtectedRoute
